import './DistributionMethods.css';
import type { ReactNode } from 'react';
import { Columns } from '@src/components/Columns/Columns';
import { Stack } from '@src/components/Stack/Stack';
import { testIdAttr, testIdFor } from '@src/components/testId';
import { Typography } from '@src/components/Typography/Typography';

export interface DistributionMethodsProps {
  title: string;
  lead: string;
  children: ReactNode;
  testId?: string;
}

/** Section heading plus distribution method cards in a row on wide screens. */
export function DistributionMethods({ title, lead, children, testId }: DistributionMethodsProps) {
  return (
    <Stack gap={5} as="section" wide testId={testId}>
      <Stack gap={2} className="distribution-methods__heading">
        <Typography as="h2" role="title/section" {...testIdAttr(testIdFor(testId, 'title'))}>
          {title}
        </Typography>
        <Typography as="p" role="body/lead" {...testIdAttr(testIdFor(testId, 'lead'))}>
          {lead}
        </Typography>
      </Stack>
      <Columns columns={3} gap={4} testId={testIdFor(testId, 'cards')}>
        {children}
      </Columns>
    </Stack>
  );
}
